//@flow
import React from 'react';

import {Collapse, makeStyles, ListItemText, Button} from '@material-ui/core';

import {useToggle} from '../../../../../../../utils/react';
import {ExpandLess, ExpandMore} from '@material-ui/icons';

type Props = {
  children: React$Node,
  label: string,
};

const useStyles = makeStyles(theme => ({
  button: {
    padding: 0,
    paddingBlock: '.75rem',
    width: '100%',
    justifyContent: 'space-between',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: 14,
    textAlign: 'left',
  },
}));

export default function SectionCollapse(props: Props) {
  const {children, label} = props;
  const [open, toggleOpen] = useToggle();

  const classes = useStyles();

  return (
    <>
      <Button variant="text" className={classes.button} onClick={toggleOpen}>
        <ListItemText disableTypography>{label}</ListItemText>
        {open ? (
          <ExpandLess style={{marginRight: 12}} />
        ) : (
          <ExpandMore style={{marginRight: 12}} />
        )}
      </Button>
      <Collapse in={open} timeout="auto">
        {children}
      </Collapse>
    </>
  );
}
